import { render } from "./BnplContainer.vue?vue&type=template&id=0db14316&scoped=true"
import script from "./BnplContainer.vue?vue&type=script&lang=js"
export * from "./BnplContainer.vue?vue&type=script&lang=js"

import "./BnplContainer.vue?vue&type=style&index=0&id=0db14316&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0db14316"]])

export default __exports__